import i18next, { i18n as i18nType } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

i18next
  // load translation using http
  .use(Backend)
  // detect user language
  .use(LanguageDetector);

export let i18n = i18next;

export const overwriteI18n = (newI18n: i18nType | null) => {
  if (!newI18n) {
    return;
  }
  i18n = newI18n;
};

export const getIsRTL = () => {
  return i18n.dir() === 'rtl';
};

export * from './resolveLocale';
